import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=2a8ae812"
import script from "./AppColorPicker.vue?vue&type=script&lang=ts"
export * from "./AppColorPicker.vue?vue&type=script&lang=ts"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&id=2a8ae812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports